import { render, staticRenderFns } from "./InboxArrowUp.vue?vue&type=template&id=08dc254d"
import script from "./InboxArrowUp.vue?vue&type=script&lang=js"
export * from "./InboxArrowUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports